import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { steps } from '../data/content';
const stepStyles = [{
  ring: 'ring-brandSoft',
  bg: 'bg-brandSoft',
  text: 'text-brand'
}, {
  ring: 'ring-flameSoft',
  bg: 'bg-flameSoft',
  text: 'text-flame'
}, {
  ring: 'ring-goSoft',
  bg: 'bg-goSoft',
  text: 'text-goDark'
}];
export function Mechanism() {
  return <section aria-labelledby="mechanism-heading" className="bg-paper pb-14 pt-4 sm:pb-20 sm:pt-8" data-id="element-123" data-mp="ykv4mrcm02f4">
      <Container data-id="element-124" data-mp="13ievcqqhu7ny">
        <SectionHeading id="mechanism-heading" eyebrow="The mechanism" title={<>
              From Your Printer to Playtime
              <span className="block" data-id="element-126" data-mp="1d9hxlvv5ssot">in 3 Simple Steps</span>
            </>} data-id="element-125" data-mp="13jyauf4bseoo" />

        <div className="relative mx-auto mt-10 max-w-[980px] sm:mt-14" data-id="element-127" data-mp="fu3zk1znmy6j">
          {/* dashed cutting guide linking the three numbers */}
          <div aria-hidden="true" className="cut-line absolute left-[17%] right-[17%] top-7 hidden sm:block" data-id="element-128" data-mp="kr45mcwi80xn" />

          <ol className="relative grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-6" data-id="element-129" data-mp="kdj28ij43xv1">
            {steps.map((step, index) => {
            const style = stepStyles[index % stepStyles.length];
            return <li key={step.number} className="flex flex-col items-center text-center" data-id="element-130" data-mp="bm0k422lv7zb" data-mpi={index}>
                  <span className={`flex h-14 w-14 items-center justify-center rounded-full bg-white font-display text-[20px] font-extrabold ring-4 ${style.ring} ${style.text}`} data-id="element-131" data-mp="6mnmqne3yiih">
                    {index + 1}
                  </span>

                  <span aria-hidden="true" className={`mt-5 flex h-12 w-12 items-center justify-center rounded-2xl text-[24px] ${style.bg}`} data-id="element-132" data-mp="3sv5li1kxr9et">
                    {step.emoji}
                  </span>

                  <h3 className="mt-4 font-display text-[19px] font-extrabold uppercase tracking-[0.08em] text-ink sm:text-[20px]" data-id="element-133" data-mp="1n0vwtihoyzd8">
                    {step.title}
                  </h3>

                  <p className="mx-auto mt-2.5 max-w-[300px] text-[16px] leading-[1.6] text-muted" data-id="element-134" data-mp="3lalb2gadch2c">
                    {step.description}
                  </p>
                </li>;
          })}
          </ol>
        </div>

        <p className="mx-auto mt-11 max-w-[620px] text-center font-display text-[18px] font-bold leading-snug text-inkSoft sm:text-[21px]" data-id="element-135" data-mp="3bhxcbfztw30z">
          A flat sheet of paper goes in — a 3D toy they built themselves comes out.
        </p>
      </Container>
    </section>;
}